import React, { ReactNode } from 'react';
import { Tab } from '@headlessui/react';
import { navigate } from 'gatsby-plugin-intl';
import { useStaticQuery, graphql } from 'gatsby';
import { useLayoutState } from '../layouts/useLayoutState';

const NavTab = ({
  children,
  onClick,
  tab_selected,
}: {
  children: ReactNode;
  onClick: () => void;
  tab_selected: boolean;
}) => {
  return (
    <Tab
      className={({ selected }) =>
        `border-b-2 p-2 text-gray-700 outline-0 ${
          tab_selected ? 'border-secondary-600' : 'border-transparent'
        }`
      }
    >
      <div onClick={onClick}>{children}</div>
    </Tab>
  );
};

interface NavBarProps {
  className: string;
}

export const NavBar = ({ className }: NavBarProps) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulSite {
        navPages {
          title
          url
          id
        }
      }
    }
  `);

  const navPages = data.contentfulSite.navPages;

  const {
    selectedNav: [selectedNav],
  } = useLayoutState();

  return (
    <Tab.Group>
      <Tab.List className={className}>
        {navPages.map((t) => (
          <NavTab
            key={t.id}
            tab_selected={selectedNav?.id === t.id}
            onClick={() => {
              navigate(`${t.url}/#main`);
            }}
          >
            {t.title}
          </NavTab>
        ))}
      </Tab.List>
    </Tab.Group>
  );
};
